import { Select } from "components"
import { Controller, useFormContext } from "react-hook-form"
import { useProductAvailableList, useSohByProduct } from "../utils/hooks"
import { useEffect } from "react"

type DropdownProductAvailableProps = {
  priceLevelName?: string
  products: ReturnType<typeof useProductAvailableList>
  location_to_id: number
}

export const DropdownProductAvailable = ({
  products,
  location_to_id
}: DropdownProductAvailableProps) => {
  const { control, setValue, watch } = useFormContext()

    const sohDestination = useSohByProduct({location_id: location_to_id, product_id: watch('product_id') })

    useEffect(() => {
      setValue('soh_destination', sohDestination.data.soh)
    }, [sohDestination.data.soh, setValue])
    

  return (
    <section>
      <Controller
        control={control}
        name="product_id"
        render={({ field, fieldState }) => (
          <Select
            isLoading={products.isLoading}
            controlClass="w-[250px]"
            placeholder="Select Item Order"
            error={fieldState.error?.message}
            ref={field.ref}
            options={products.dropdown}
            value={
              field.value
                ? products.dropdown.find(
                    (item) => item.value === field.value.toString()
                  )
                : null
            }
            onChange={(product: any) => {
              field.onChange(product?.value)

              setValue("product_name", product?.product_name ?? "")

              setValue("product_barcode", product?.product_barcode ?? "")

              setValue(
                "mr_unit_id",
                product?.sell ? product?.unit_sell_measure_id : product?.unit_convention_id
              )

              setValue(
                "mr_unit_name",
                product?.sell ? product?.unit_sell_measure_name : product?.unit_convention_name
              )
              setValue("soh", product?.soh ?? 0)
            }}
          />
        )}
      />
    </section>
  )
}
